export default __webpack_public_path__ + "static/media/card-pengetahuan.0b2ac5e5.webp";